import { render, staticRenderFns } from "./holdOrderDialog.vue?vue&type=template&id=a413ac9a&scoped=true"
import script from "./holdOrderDialog.vue?vue&type=script&lang=js"
export * from "./holdOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./holdOrderDialog.vue?vue&type=style&index=0&id=a413ac9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a413ac9a",
  null
  
)

export default component.exports